import React from 'react';
import LinkRounded from '@mui/icons-material/LinkRounded';
import { useRecordContext } from 'react-admin';

export function Url() {
  const record = useRecordContext() || {};
  const { url } = record;
  if (!url) {
    return '-';
  }
  return (
    <a href={url} target="_blank" rel="noopener noreferrer">
      <LinkRounded />
    </a>
  );
}

Url.defaultProps = {
  label: 'Link',
};
